export default __webpack_public_path__ + "196e64fa820a2ddc5a4417a8b4d0e138.png";